import { Component, Input, inject, OnInit } from '@angular/core';
import { Course, CourseCategory } from 'TrainingTrackingDataTypes';

import { FormsModule } from '@angular/forms';
import { UserService } from 'BaseServices/user-service';
import { CourseService } from 'TrainingTrackingServices/course-service';
import { dialogData, genericDialogComponent } from '../genericDialog';
import { CourseCategoryService } from 'TrainingTrackingServices/course-categories-service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { SharedFunctionsService } from 'BaseServices/sharedFunctions.service';
import { dialogInputTitleComponent } from '../../../../../../src/app/elements/dialog-input-title.component';
import { GenericButtonComponent } from '../../../../../../src/app/buttons/generic-button/generic-button.component';
import { DeleteButtonComponent } from '../../../../../../src/app/buttons/delete-button/delete-button.component';
import { SaveButtonComponent } from '../../../../../../src/app/buttons/save-button/save-button.component';

@Component({
    selector: 'app-course-category-dialog',
    imports: [
    FormsModule,
    MatButtonModule,
    dialogInputTitleComponent,
    DeleteButtonComponent,
    SaveButtonComponent
],
    templateUrl: './course-category-dialog.component.html',
    styleUrls: [
        '../../../../../../src/app/general-styles/dialogs.css',
        './course-category-dialog.component.css',
    ]
})
export class CourseCategoryDialogComponent
  extends genericDialogComponent
  implements OnInit
{
  readonly data = inject<dialogData<CourseCategory[]>>(MAT_DIALOG_DATA);
  @Input() courseCategoryData!: CourseCategory;
  allCourses: Course[] = [];
  currentUser = this.userService.currentUser;
  dialogInputTitleComponent = dialogInputTitleComponent;
  genericButtonComponent = GenericButtonComponent;

  constructor(
    public override dialogRef: MatDialogRef<CourseCategoryDialogComponent>,
    private userService: UserService,
    private courseService: CourseService,
    private courseCategoryService: CourseCategoryService,
  ) {
    super(dialogRef);
    this.courseCategoryData = this.data.data[0];
  }

  ngOnInit(): void {
    this.courseService.getCourses().subscribe((result) => {
      this.allCourses = result;
    });
  }

  /**
   * Updates the CourseCategory, we send the original category with for logging purposes.
   */
  saveChanges() {
  this.courseCategoryService.upsertCourseCategory(this.courseCategoryData)
    .subscribe({
      next: (result) => {
        this.dialogRef.close(true);
      },
    });
  }
  /**
   * Deletes a CourseCategory if no courses are part of it, by using deleteCourseCategory service.
   * @returns
   */
  deleteCourseCategory() {
    if (
      this.allCourses.some(
        (value) => value.courseCategory!.id == this.courseCategoryData.id
      )
    ) {
      window.alert('Kursuskategorien har kurser og kan derfor ikke slettes.');
      return;
    }

    if (
      !confirm(
        "Er du sikker på at du vil slette kursuskategorien '" +
          this.courseCategoryData.name +
          "'?"
      )
    ) {
      return;
    }
    this.courseCategoryService
      .deleteCourseCategory(this.courseCategoryData)
      .subscribe((result) => {
        this.dialogRef.close(true);
      });
  }
}
